/**
 * Sign-in OTP never collects TERMS + PRIVACY.
 * Consents are register-only (`RegisterScreen` / RegistrationConsentsField).
 * Grant flags are ignored so OTP login cannot surface Právní souhlasy.
 */
export function shouldCollectOtpConsents(
  _otpHasLegalGrant?: boolean,
  _accountHasLegalGrant?: boolean
): boolean {
  return false;
}
